import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-51c58440")
const _hoisted_1 = { class: "pb-16" }
const _hoisted_2 = { class: "layout-header mb-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
_popScopeId()

import { useRoute } from 'vue-router';


export default _defineComponent({
  setup(__props) {

const route = useRoute();

function getReturnRoute() {
  const queryReturnRoute = route.query?.returnRoute as string;

  if (queryReturnRoute) {
    const queryReturnParams = route.query?.returnParams as string;

    if (queryReturnParams) {
      return { name: queryReturnRoute, params: JSON.parse(queryReturnParams) };
    }

    return { name: queryReturnRoute };
  }

  return { name: 'home' };
}

return (_ctx: any,_cache: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        to: getReturnRoute()
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BalIcon, {
            name: "x",
            size: "lg"
          })
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode(_component_router_view, {
      key: _ctx.$route.path
    })
  ]))
}
}

})